import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { Deliverables } from './components/Deliverables';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-body selection:bg-peach/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Hook data-id="element-3" />
        <Problem data-id="element-4" />
        <FailedAttempts data-id="element-5" />
        <Mechanism data-id="element-6" />
        <Deliverables data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <Pricing data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}